import React, { Component } from "react";
import PropTypes from "prop-types";
import ReactDOM from "react-dom";
import styled from "styled-components";
//
let Isotope = {};
if (typeof document !== "undefined") {
  Isotope = require("isotope-layout");
  require("isotope-packery");
}
//
class Grid extends Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
  }

  componentDidMount() {
    this.initGrid();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.filter !== this.props.filter) {
      const { filter } = this.props;
      this.iso.arrange({
        filter
      });
    } else {
      // if (prevProps.children !== this.props.children) {
      this.initGrid();
      // }
    }
  }

  componentWillUnmount() {
    if (typeof document !== "undefined") {
      this.iso.destroy();
    }
  }

  // shouldComponentUpdate() {
  //   return false;
  // }

  initGrid = () => {
    if (typeof document !== "undefined") {
      const parent = this.myRef.current;

      this.iso = new Isotope(parent, {
        itemSelector: ".grid-item",
        layoutMode: this.props.layoutMode,
        packery: {
          columnWidth: ".grid-sizer"
        },
        percentPosition: true
      });
    }
  };

  render() {
    const { children } = this.props;

    return (
      <GridStyled ref={this.myRef}>
        <GridSizer className="grid-sizer" />
        {children}
      </GridStyled>
    );
  }
}

Grid.defaultProps = {
  filter: "*",
  layoutMode: "packery"
};

Grid.propTypes = {
  filter: PropTypes.string,
  layoutMode: PropTypes.string
};

export default Grid;
//
const GridStyled = styled.div``;
const GridSizer = styled.div`
  left: 0;
  padding: 0;
  position: absolute;
  top: 0;
  width: 100%;

  @media (min-width: 768px) {
    height: 0;
    padding: 14.0625% 0 0;
    width: 25%;
  }
`;
